import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';


@Injectable({
    providedIn: 'root'
})
export class TovpilLangService {

    constructor(private translateService: TranslateService, public primeNGConfig: PrimeNGConfig) { }

    translate(lang: string) {

        // Borra la caché
        this.primeNGConfig.setTranslation(null);
        this.translateService.resetLang('');

        // Agrega los idiomas disponibles
        this.translateService.addLangs(['en', 'es', 'fil', 'fr', 'it', 'pt', 'sl', 'sq']);

        // Establece el idioma por defecto y el idioma actual
        this.translateService.setDefaultLang(lang);
        this.translateService.use(lang);

        // Obtiene y configura las traducciones para 'primeng'
        this.translateService.get('primeng').subscribe(res => {
            //console.log(this.primeNGConfig.getTranslation('dayNamesMin'));
            this.primeNGConfig.setTranslation(res);
            //console.log(this.primeNGConfig.getTranslation('dayNamesMin'));
        });
    }

}

